<template>
  <v-container>
    <div
      v-if="loading"
      class="d-flex justify-center align-center"
      style="height: 100vh;"
    >
      <v-progress-circular
        indeterminate
        color="#2661FF"
        size="80"
      ></v-progress-circular>
    </div>
    <div v-else>
      <v-row class="px-2">
        <v-col cols="12" md="6">
          <h2
            class="text-h6 grey--text text--darken-3 font-weight-medium mb-2 ml-6 text-color"
            style="font-size: 20px !important;"
          >
            {{ $t('signup.syncLeads.title') }}
          </h2>
          <v-breadcrumbs divider=">" :items="breadcrumbs" class="py-2" />
        </v-col>
      </v-row>

      <v-row class="mt-4">
        <v-col cols="12">
          <v-card class="rounded-lg custom_card" flat>
            <v-card-title class="text-color mt-2 ml-1">
              <h2
                class="text-h6 grey--text text--darken-3 font-weight-medium mb-2 ml-6 text-color"
                style="font-size: 20px !important;"
              >
                {{ $t('signup.syncLeads.title') }}
              </h2>
            </v-card-title>
            <v-card-text class="px-10">
              <v-row>
                <v-col cols="12" class="d-flex justify-start align-center">
                  <p class="text-color text-body-2 pl-2">
                    {{ $t('signup.syncLeads.description') }}
                  </p>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-text>
              <v-row class="justify-center">
                <v-col cols="12" md="4" class="text-center">
                  <v-btn
                    color="#2661FF"
                    large
                    class="rounded-lg white--text"
                    @click="syncUsers"
                    :loading="syncLoading"
                  >
                    <v-icon left>sync</v-icon>
                    {{ $t('signup.syncLeads.button') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Vue from 'vue'
import { mapActions } from 'vuex'

export default {
  name: 'SyncUsers',
  data () {
    return {
      loading: false,
      syncLoading: false,
      breadcrumbs: [
        {
          text: 'Signup',
          disabled: true
        },
        {
          text: 'Sync Users',
          disabled: false
        }
      ]
    }
  },
  methods: {
    ...mapActions({
      syncUsersAction: 'signup/syncUsers'
    }),
    async syncUsers () {
      try {
        this.syncLoading = true
        await this.syncUsersAction()
      } catch (error) {
        Vue.noty.error(error.message)
      } finally {
        this.syncLoading = false
      }
    }
  }
}
</script>

<style lang="scss">
.custom_card {
  border-radius: 12px !important;
  border: 1px solid #d0d3db !important;
}

.text-color {
  color: #344054 !important;
}
</style>
